import { MODALS } from "@/constants/modals"
import { detailsIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"
import DirectionText from "../DirectionText/DirectionText"
import IconOption from "../TableOptions/IconOption"

export default function LongText({
  text,
  length = 150,
}: {
  text: string
  length?: number
}) {
  const editModalState = useStore((store) => store.editModalState)

  if (!text) return ""
  return (
    <div className=" d-flex gap-3">
      <DirectionText
        className="m-0"
        style={{ width: "400px", maxWidth: "500px", textWrap: "wrap" }}
      >
        {text.length > length ? `${text.slice(0, length)} ...` : text}
      </DirectionText>
      {text.length > length && (
        <IconOption
          tooltip="Show Text"
          onClick={() => editModalState(MODALS.utils.showText, text)}
          icon={detailsIcon}
        />
      )}
    </div>
  )
}
